<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>思想汇报</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 添加汇报 -->
		<addHb :type="type" ref="addhb" @dataList="dataList"></addHb>
		<!-- 预览 -->
		<Preview :imgList="imgList" @clearPre="imgList = []" :bsid="bsid"></Preview>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="dydetail">
						<div class="dyinfo">
							<div class="dyimg">
								<img src="@/assets/images/adminMan.png" v-if="info.u_picture==''||info.u_picture==null||info.u_picture.search('http')==-1">
								<img :src="info.u_picture" v-else>
							</div>
							<div class="dyname">
								<div>{{info.u_name}}</div>
								<div>{{info.cy_zz}}</div>
							</div>
						</div>
						<div><el-button type="primary" size="small" @click="$router.go(-1)">返回上级</el-button></div>
					</div>
					<div class="change">
						<el-button 
							v-if="$store.state.user.userinfo.flag==3" 
							@click="$refs.addhb.openEdit();type = 'add';" size="small" type="primary">添加汇报</el-button>
						<div v-else></div>
						<div style="display: flex;
						justify-content: space-between;align-items: center;">
							<el-select
								size="small"
								style="margin-right: 10px;width: 100px !important;" 
								v-model="$route.query.year" placeholder="选择年份"
								@change="selectYear"
								clearable>
								<el-option
									v-for="item in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
							<i @click='isTable = 1;clearTable();dataList()' class="el-icon-s-unfold" :class="isTable==1?'selectI':''"></i>
							<i @click='isTable = 2;clearTable();dataList()' class="el-icon-menu" :class="isTable==2?'selectI':''"></i>
						</div>
					</div>
					<div class="selectdata" v-if="isTable == 1">
						<template>
							<el-table
								:header-cell-style="{background:'#f5f7fa',color:'#000'}"
								:data="tableData"
								stripe
								border
								style="width: 100%">
								<el-table-column
									prop=""
									type="index"
									width="50"
									align="center"
									label="序号">
								</el-table-column>
								<el-table-column
									prop="title"
									label="文章标题">
								</el-table-column>
								<el-table-column
									prop="day"
									width="120"
									align="center"
									label="时间">
								</el-table-column>
								<el-table-column
									width="150"
									align="center"
									label="操作">
									<template slot-scope="scope">
										<el-button @click="showDetail(scope.row)" type="text" size="small">预览</el-button>
										<el-button 
											v-if="$store.state.user.userinfo.flag==3"
											@click="del(scope.row)"
										 type="text" size="small">删除</el-button>
										<el-button @click="edit(scope.row)"
											v-if="$store.state.user.userinfo.flag==3"
										type="text" size="small">替换文件</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>
					<div class="selectdata" v-else>
						<div class="imglist">
							<div class="img_item" 
								v-if="tableData.length >0"
								@click="showDetail(item)"
								v-for="item in tableData">
								<img :src="item.ment_url[0]" v-if="item.bsid == 1&&item.ment_url.length>0">
								<img src="@/assets/images/sxhb_file.png" v-if="item.bsid==2">
								<div class="words">{{item.title}}</div>
							</div>
							<div class="nodata" v-if="tableData.length == 0">
								<img src="@/assets/images/nodata.jpg" >
							</div>
						</div>
					</div>
					<Page :totalPage="totalPage" :pageSize="10" @changedata="changePage"></Page>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import detail from './mixins/detail.js'
	export default{
		mixins:[detail]
	}
</script>

<style lang="scss" scoped>
	.dydetail{
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 50px;
		.dyinfo{
			display: flex;
			align-items: center;
			.dyimg{
				width: 100px;
				height: 100px;
				border-radius: 50%;
				margin-right: 20px;
				img{
					width: 100%;
					height: 100%;
					border-radius: inherit;
				}
			}
			.dyname{
				font-size: 14px;
				color: #707070;
				div:nth-child(1){
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 15px;
				}
			}
		}
	}
	.change{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		i{
			cursor: pointer;
			font-size: 22px;
			color: #707070;
			margin-left: 10px;
		}
		i:hover{
			color: #BB0000;
		}
		.selectI{
			color: #BB0000;
		}
	}
	.imglist{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		.img_item{
			cursor: pointer;
			width: 150px;
			margin-right: 15px;
			margin-bottom: 15px;
			border-radius: 10px;
			img{
				width: 100%;
				height: 200px;
				border-radius: 10px;
				background: #ededed;
			}
			.words{
				font-size: 14px;
				color: #707070;
				line-height: 25px;
				margin: 10px 0 5px 0;
			}
		}
		.img_item:hover{
			opacity: 0.9;
		}
		.plus{
			height: 200px;
			cursor: pointer;
			border: 1px solid #ededed;
			border-radius: 10px;
			text-align: center;
			line-height: 200px;
			font-size: 50px;
			color: #ededed;
		}
	}
</style>

